/* 🤖 this file was generated by svg-to-ts */
export const fthrArrowRight: {
    name: 'fthr-arrow-right';
    data: string;
} = {
    name: 'fthr-arrow-right',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-arrow-right" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>`,
};
